import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Santiago_Hernandez, Mario_sepulveda
 * @updateBy Sebastian Rios Echverri
 * Versiones corregidas: 1.01.0054
 */
/**
 * Custom con funciones adicionales al formulario de correccion envasado produccion 
 **/
class CustomRecepcionDevolucionEnvasadoFinal extends FormJaivana.form {
    constructor(props) {
        super(props);
        this.initForm                                       = this.initForm.bind(this);
        this.successDatosFicha                              = this.successDatosFicha.bind(this);
        this.successTbRecepcionDevolucion                   = this.successTbRecepcionDevolucion.bind(this);
        this.gridOptionsRecepcionDevolucion                 = Object.assign({}, this.gridOptions);
        this.setButtonRecepcion                             = this.setButtonRecepcion.bind(this);
        this.setChangeButtonRecepcionclick                  = this.setChangeButtonRecepcionclick.bind(this);    
        this.selectOptions                                  = [];
        this.successSelectBodega                            = this.successSelectBodega.bind(this);
        this.setSelectBodega                                = this.setSelectBodega.bind(this);
        this.valueChange                                    = this.valueChange.bind(this);
        this.setSelectMaquina                               = this.setSelectMaquina.bind(this);
        this.grabarBodega                                   = this.grabarBodega.bind(this);
        this.successGrabarBodega                            = this.successGrabarBodega.bind(this);
        this.uploadTbRecepcionDevolucion                    = this.uploadTbRecepcionDevolucion.bind(this);
        this.successButtonRecepcionClick                    = this.successButtonRecepcionClick.bind(this);
        this.terminarRecepcionDevEnvasadoFinal              = this.terminarRecepcionDevEnvasadoFinal.bind(this);
        this.avisoTerminacionFicha                          = this.avisoTerminacionFicha.bind(this);
        this.formulacionFicha                               = '';
        this.procedimientoFicha                             = ''; 
        this.openModal = true;
        this.dataTable = [];
        
        this.verFormula                                       = this.verFormula.bind(this);
        this.successVerFormula                                = this.successVerFormula.bind(this);
        this.gridOptionsVerFormula                            = Object.assign({}, this.gridOptions);
    }

    initForm(){
        console.log('Recepcion Devolucion Envasado Final, @version: 1.01.0054 -->, @author: Cristian Ciro');
        this.getField('btnTerminar').setClick(this.avisoTerminacionFicha);

        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'iddatos', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successDatosFicha,
            error: this.error_,
            general: this.generalFormatPmv
        });

        /*this.generalFormat.nombre_accion = '460-Retorna_datos_ficha'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successDatosFicha,
                error:this.error_,
                general: this.generalFormat
            });*/
        
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasitems', operacion: 'bodega', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successSelectBodega,
            error: this.error_,
            general: this.generalFormatPmv
        });

        /*this.generalFormat.nombre_accion = '460-Retorna_los_datos_de_las_bodegas'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successSelectBodega,
                error:this.error_,
                general: this.generalFormat
            });*/

        this.generalFormatPmv = { tipo_servicio: 'prod-fichasrecepciondevolucion', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTbRecepcionDevolucion,
            error: this.error_,
            showMessage :false,
            general: this.generalFormatPmv
        });

        /*this.generalFormat.nombre_accion = '460-Retorna_tb_fichas_recepcion_devolucion'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successTbRecepcionDevolucion,
                error:this.error_,
                general: this.generalFormat,
                showMessage :false
            });*/

        this.getField('btn_verformula').setClick(this.verFormula);
    }

    verFormula(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'verformula', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successVerFormula,
            error: this.error_,
            showMessage: false,
            general: this.generalFormatPmv
        });
    }

    successVerFormula(data){
        if (data.estado_p === 200 && data.data.length >= 1) {
            this.getField('modal_verformula').handleClickOpen();
            this.getField('tb_verformula').toggle(true);
            this.gridOptionsVerFormula['rowData'] = data.model;
            let configCell = new Map();
            configCell.set('nombre_articulo',{headerName: 'Nombre Artículo'});
            configCell.set('version',{headerName: 'Versión'});
            configCell.set('produccion_formulas_versiones',{headerName: 'Producción Fórmulas Versiones'});
            configCell.set('estado_descripcion',{headerName: 'Estado Descripción'});
            this.getField('tb_verformula').initData(this.gridOptionsVerFormula, configCell);
        }else if (data.estado_p === 404){
            this.alertGeneral.toggle(true,'No hay datos',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }else{
            this.alertGeneral.toggle(true,'Error al consumir el servicio.',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }
    }
    
    successDatosFicha(data){
        if (data.estado_p === 200 && data.model !== undefined && data.model.length > 0){
            this.getField('lista_items_ficha').setVisible(true);
            this.getField('lista_items_ficha').setItemsFichas(data.model);
            this.formulacionFicha = data.model[0].codigo_producto_formulacion;
            this.procedimientoFicha = data.model[0].procedimiento;
        }else{
            this.getField('lista_items_ficha').setVisible(false);
            this.formulacionFicha = '';
            this.procedimientoFicha = '';
        }
    }

    successTbRecepcionDevolucion(data){
        if (data.estado_p === 200 && data.model !== undefined && data.model.length > 0){
            this.gridOptionsRecepcionDevolucion['rowData']=[];
            this.getField('TbRecepcionDevolucion').initData(this.gridOptionsRecepcionDevolucion);
            let configCellcol = new Map();
            configCellcol.set('recibir', {cellRenderer:this.setButtonRecepcion, field:'recibir'});
            configCellcol.set('codigo_bodega',{cellRenderer:this.setSelectBodega, cellStyle: { backgroundColor: "rgb(238,238,238)",borderRadius:"5px",color:'rgb(0, 86, 201)'},width: 150, field: 'codigo_bodega'});
            this.getField('TbRecepcionDevolucion').toggle(true);
            this.gridOptionsRecepcionDevolucion['rowData'] = data.model;
            this.dataTable = data.model;
            this.gridOptionsRecepcionDevolucion.paginationPageSize = 100;
            this.getField('TbRecepcionDevolucion').initData(this.gridOptionsRecepcionDevolucion, configCellcol);
        }else{ 
          this.getField('TbRecepcionDevolucion').toggle(false);
          this.getField('fieldAlert').toggle(true,"No se encuentra ninguna recepción","warning");
          this.dataTable = []
        } 
    }

    setButtonRecepcion(props){
        let button = document.createElement("input");
        button.onclick = () => this.setChangeButtonRecepcionclick(props.data);
        button.setAttribute("class","buttonStyle");
        button.setAttribute("type","button");
        button.setAttribute("value","Recibir");
        return this.createElementJaivana(button); 
    }

    setChangeButtonRecepcionclick(data){
        let datos = {
            datos:{
                id:data.id,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichasrecepciondevolucion', operacion: 'recibir', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successButtonRecepcionClick,
            error: this.error_,
            showMessage :false,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '460-Actualiza_recepcion_devolucion_recibido'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'PUT',
                body:body,
                success:this.successButtonRecepcionClick,
                error:this.error_,
                general: this.generalFormat
            }); */
    }

    successButtonRecepcionClick(response){
        if(response.estado_p === 200){
            this.getField('fieldAlert').toggle(true,"Se actualizo a recibido correctamente","success");
            this.uploadTbRecepcionDevolucion();
        }else{
            this.getField('fieldAlert').toggle(true,"No se actualizo a recibido correctamente","warning");
        }
    }

    successSelectBodega(data){
        if(data.estado_p === 200){
            this.selectOptions = data.model;
        }else {
            this.getField('fieldAlert').toggle(true,"No se tienen bodegas para mostrar","error");
        }
    }

    setSelectBodega(props){
        let maquina = props.data.codigo_bodega;
        let select = document.createElement("select");
        let div = document.createElement('div');
        select.setAttribute('class','selectStyle1');
        select.onchange = (event) => this.valueChange(event,props.data.id);
        let opciones = this.setSelectMaquina();
        this.valor_idMaq = 1;
        opciones.map((item) => {
            select.appendChild(item);
            if(item.value === maquina)
                this.valor_idMaq  = item.value;
            return null;
        })
        div.appendChild(select)
        if(maquina === null || maquina === undefined || maquina === ' ')
            this.valido = false;
        else
            select.value = this.valor_idMaq ;
        return this.createElementJaivana(div);
    }

    valueChange(props,celda){
        let x = parseInt(props.target.value);
        if(!isNaN(x))
            this.grabarBodega(celda,x);
    }

    setSelectMaquina(){
        let opcionN = document.createElement('option');
        opcionN.setAttribute('value',' ');
        opcionN.textContent = 'Ninguno';
        let data = [opcionN];
        
        this.selectOptions.map((item) =>{
            if(item.codigo_bodega !== '36'){//Por solicitud de pintunal, si llega la bodega 36 no se muestra en el select
                let opcion = document.createElement('option');
                opcion.setAttribute('value',item.codigo_bodega);
                opcion.textContent = item.nombre_bodega;
                data.push(opcion);
            }
            return null;
        })
        return data;
    }

    grabarBodega(idCell, bodega_id){
        this.getField('codigo_bodega').setValue(bodega_id)
        let datos = {
            datos:{
                id:idCell,
                codigo_bodega: this.getField('codigo_bodega').getValue(),
                actividad_id:this.props.data.actividad_id
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichasrecepciondevolucion', operacion: 'bodega', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successGrabarBodega,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '460-Actualiza_bodega_en_recepcion_devolucion'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'PUT',
                body:body,
                success:this.successGrabarBodega,
                error:this.error_,
                general: this.generalFormat
            }); */
    }

    successGrabarBodega(response){
        if(response.estado_p === 200){
            this.getField('fieldAlert').toggle(true,"Se actualizo la bodega correctamente","success");
            this.uploadTbRecepcionDevolucion();
        }else{
            this.getField('fieldAlert').toggle(true,"No se actualizo la bodega correctamente","error");
        }
    }

    uploadTbRecepcionDevolucion(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }
        
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasrecepciondevolucion', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTbRecepcionDevolucion,
            error: this.error_,
            showMessage :false,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '460-Retorna_tb_fichas_recepcion_devolucion'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successTbRecepcionDevolucion,
                error:this.error_,
                general: this.generalFormat,
                showMessage :false
            });*/
    }
    terminarRecepcionDevEnvasadoFinal(){
        this.getField('confirmModalCustom').toggle(false);
        if(this.openModal === true){
            this.openModal = false;
            this.getField('btnTerminar').setDisabled(true);
            this.formulacionFicha = '';
            this.procedimientoFicha = '';
            this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);
            this.getField('proceso_id').setValue(this.props.data.proceso_id);
            this.getField('actividad_id').setValue(this.props.data.actividad_id);
            this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);
            let datos = {
                datos:{
                    id_formulario: this.formId,
                    produccion_fichas_id:this.getField('produccion_fichas_id').getValue(),
                    proceso_id:this.getField('proceso_id').getValue(),
                    actividad_id:this.getField('actividad_id').getValue(),
                    actividad_configuracion_id:this.getField('actividad_configuracion_id').getValue(),
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'prod-fichasrecepciondevolucion', operacion: 'aceptar', operacion_tipo: 'crear' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'POST',
                body: datos,
                success: this.successCloseEstage,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = "460-Permite_terminar_el_proceso_generando_el_traslado_y_los_ajustes"; 
            this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'POST',
                body:body,
                success: this.successCloseEstage,
                error:this.error_,
                general: this.generalFormat
            });*/
        }
        
    }
    avisoTerminacionFicha(){
        if(this.dataTable.length > 0){
            this.getField('fieldAlert').toggle(true,"Aun hay items por recibir","error");
        }else{
            this.openModal = true;
            this.getField('confirmModalCustom').setTitleAndContent('Finalizar Ficha', `Se finalizara la ficha de la formulación ${this.formulacionFicha}: ${this.procedimientoFicha}`);//antes de ser eliminado, se ejecuta la funcion que pide confirmacion
            this.getField('confirmModalCustom').setClickDialog(this.terminarRecepcionDevEnvasadoFinal);
            this.getField('confirmModalCustom').toggle(true);
        }
    }
}//this.formulacionFicha `Se dara por terminada la ficha ${this.formulacionFicha}`

FormJaivana.addController("prod-fichasrecepciondevolucion",CustomRecepcionDevolucionEnvasadoFinal);
export default CustomRecepcionDevolucionEnvasadoFinal;